import { findLatestPeriod, getQueryValue } from '@zorro/common-utils';
import { useAppRouter, useMonolithQuery } from '@zorro/web/ui-utils';

import { FullPageLoader } from '../FullPageLoader';

type Props = {
  employerId: string;
  employeeId: string;
  isDon?: boolean;
};

/* eslint-disable sonarjs/cognitive-complexity */
export const EmployeePageRedirect = ({
  employerId,
  employeeId,
  isDon = false,
}: Props) => {
  const { navigateToRoute, router, isNavigating } = useAppRouter();
  const { data: onboardingPeriods, isFetching } = useMonolithQuery({
    method: 'onboardingPeriodsControllerFindMany',
    params: [employeeId],
  });

  if (isNavigating || isFetching) {
    return <FullPageLoader />;
  }

  const initialOPId = getQueryValue(router.query.initialOPId);
  if (initialOPId) {
    if (isDon) {
      navigateToRoute(
        'DON_EMPLOYEE_PLANS_TAB',
        [
          {
            employerId,
            employeeId,
            onboardingPeriodId: initialOPId,
          },
        ],
        {},
        true
      );
    } else {
      navigateToRoute(
        'OPS_EMPLOYEE_PLANS_TAB',
        [
          {
            employerId,
            employeeId,
            onboardingPeriodId: initialOPId,
          },
        ],
        {},
        true
      );
    }
  } else if (onboardingPeriods) {
    const latestPeriod = findLatestPeriod(onboardingPeriods);
    if (latestPeriod) {
      if (isDon) {
        navigateToRoute(
          'DON_EMPLOYEE_PLANS_TAB',
          [
            {
              employerId,
              employeeId,
              onboardingPeriodId: latestPeriod.id,
            },
          ],
          {},
          true
        );
      } else {
        navigateToRoute(
          'OPS_EMPLOYEE_PLANS_TAB',
          [
            {
              employerId,
              employeeId,
              onboardingPeriodId: latestPeriod.id,
            },
          ],
          {},
          true
        );
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (isDon) {
        navigateToRoute(
          'DON_EMPLOYEE_NO_ENROLLMENTS',
          [{ employerId, employeeId }],
          {},
          true
        );
      } else {
        navigateToRoute(
          'OPS_EMPLOYEE_NO_ENROLLMENTS',
          [{ employerId, employeeId }],
          {},
          true
        );
      }
    }
  }

  return <FullPageLoader />;
};
